/**
 * Wires EntityHistoryPanel to the entityHistory callable. Coverage-excluded
 * (SDK wiring); the panel itself and its pure helpers carry the tests —
 * matches AnnotationsContainer's split.
 */
/* c8 ignore start */
import { useEffect, useState } from 'react';
import { callEntityHistory } from '../firebase/atlasApi.js';
import type { EntityHistoryEntry } from '../state/atlasApiTypes.js';
import { EntityHistoryPanel } from './EntityHistoryPanel.js';

export function EntityHistoryContainer({ entityId }: { entityId: string }): React.JSX.Element {
  const [entries, setEntries] = useState<EntityHistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    callEntityHistory(entityId)
      .then((result) => {
        if (!cancelled) setEntries(result);
      })
      .catch((err) => {
        console.error('[atlas] entityHistory failed:', err);
        if (!cancelled) setEntries([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [entityId]);

  return <EntityHistoryPanel entityId={entityId} entries={entries} loading={loading} />;
}
/* c8 ignore stop */
